export default "__VITE_ASSET__BYBt0wq4__"